import checkData from "./data/checkData";
import find from "lodash/find";
import cloneDeep from "lodash/cloneDeep";
import senders from "./emailsSenders";
import { GameData } from "../GameData";
import { Email } from "../Email";

export interface Sender {
  key: number;
  email: string;
  fullName: string;
  avatar: string;
}

export default function check(gameData: GameData) {
  const { thresholds } = checkData;
  let messages = cloneDeep(checkData.messages);
  messages = messages.map((mes) => ({ ...mes, send: false }));

  thresholds.forEach((threshold) => {
    const variable = find(gameData.currentBusinessPlan.variables, {
      key: `${threshold.id}`,
    }) as { name: string; value: number; year: number; submission: number };
    if (!variable) {
      // console.log(
      // 	`Fatal -> checking feedbacks can't find variable: ${businessPlan.submission}:${
      // 		threshold.id
      // 	}`
      // );
      return;
    }
    const inSubmission =
      gameData.currentBusinessPlan.submission >= threshold.fromSubmission;
    const notInRange =
      Number(variable.value) < Number(threshold.min) ||
      Number(variable.value) > Number(threshold.max);
    if (inSubmission && notInRange) {
      //console.log(`Triggered: ${threshold.feedbackID}, variable: ${variable.name} - year: ${variable.year} - sub: ${variable.submission}`)
      let message = find(messages, { id: threshold.feedbackID }) as {
        send: boolean;
        id: string;
        isRead: boolean;
        hits: number;
        cost: number;
        subject: string;
        from: number;
        text: string;
      };
      if (message) {
        message.send = true;
      }
    }
  });

  const messagesToSend = messages.filter(({ send }) => send);

  if (messagesToSend.length === 0) {
    let message = find(messages, { id: "MSG19" }) as {
      send: boolean;
      id: string;
      isRead: boolean;
      hits: number;
      cost: number;
      subject: string;
      from: number;
      text: string;
    };
    if (message) {
      message.send = true;
      messagesToSend.push(message);
    }
  }

  const result: Email[] = [];

  for (const message of messagesToSend) {
    const hearts = gameData.hearts - message.hits;
    const money = gameData.money - message.cost;
    gameData.hearts = hearts <= 0 ? 0 : hearts;
    gameData.money = money <= 0 ? 0 : money;
    const sender = find(senders, { key: message.from })! as Sender;
    result.push(
      new Email(
        `${message.id}-${gameData.currentBusinessPlan.submission}`,
        new Date(),
        sender,
        false,
        message.subject,
        message.text,
        []
      )
    );
  }

  return result;
}
